<template>
  <div class="menuLogin">
    <div class="mainLogin" v-if="!isAuth">
      <ul>
        <li>
          <router-link to="/auth/register">회원가입</router-link><span>·</span>
        </li>
        <li>
          <router-link to="/auth/findid">아이디찾기</router-link>
          <span>·</span>
          </li>
        <li>
          <router-link to="/auth/reset_pw">비밀번호 재설정</router-link>
        </li>
        <li>
          <router-link to="/auth/login" class="menu_btn btn_login">로그인</router-link>
        </li>
      </ul>
    </div>
    <div class="mainLogin" v-else>
      <ul>
        <li>
          <div class="myInfo">
            <div class="myNick mywrapper">
              <img :src="`${require('@/assets/imgs/level/'+user.level+'.png')}`"> {{user.nic}}
            </div>
            <div class="myPoint mywrapper">
              <img src="@/assets/imgs/icon_point.png"> {{addComma(user.point)}}
            </div>
            <div class="myPoint mywrapper newMessage" @click="goMessagePage()">
                <img src="@/assets/imgs/icon_msg.gif" class="ico_msg" :class="{'animate-ping':newMessage>0}">
                <img src="@/assets/imgs/icon_msg.gif" >
                  <span :class="{newAlert:newMessage>0}" id="msgCount">{{addComma(newMessage)}}</span>
            </div>
          </div>
        </li>
        <li>
          <button class="btn_mypage menu_btn" @click="mypage">마이페이지</button>

        </li>
        <li>
          <button @click="logout" class="btn_login menu_btn">로그아웃</button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { auth } from '@/components/mixins/auth.js';
import { comma } from '@/components/mixins/comma.js';
import { newPop } from '@/utils/popup.js';
export default {
  name:'menulogin',
  mixins:[ auth,comma],
  methods: {
    goMessagePage(){

      //this.$router.push('/mypage/message');
      const url="/pop/message/";
      newPop('Msg_window',url,'','',800,500);
    },
    logout() {
      this.$store.dispatch("logout");
      this.$flashMessage.show({
        type: "info",
        title: "로그아웃되었습니다",
        message: "",
      });
      //this.$router.replace('/');
      window.location.reload();
    },
    mypage(){
        this.$router.push('/mypage')
    },


  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/ani_infinite";
.menuLogin {
  .mainLogin {
    ul {
      margin-top:5px;
      display: flex;
      align-items: center;
    }
    li {
      margin: 0 0.1rem;
      a{
        font-size:12px;
        padding:0;
      }
      a:hover{
        border:none;
        font-weight:bold;
      }
      .myInfo{
        display:flex;
        font-weight:bold;
        .mywrapper{
          background:#fff;
          border-radius:5px;
          padding:5px 5px;
          display: flex;
          align-items: center;
        }
        .myNick{
          max-width: 120px;
          overflow-x: hidden;
        }
        .myPoint{
          margin-left:5px;
        }
        .newMessage{
          cursor:pointer;
          .ico_msg{
            position:absolute;
          }
          .animate-ping{
            animation: ping 1s cubic-bezier(0,0,.2,1) infinite;
            opacity:.7;
          }

        }
      }
    }
    li span {
      font-family: Gulim;
      padding-left: 10px;
    }
    .menu_btn{
      font-size:12px;
      font-weight:bold;
      padding: 0 5px 0 5px;
      color:white;
      line-height: 34px;
      display: block;
      text-decoration: none;
      border-radius:5px;
    }
    .btn_login{
      background: #c30;
      border: 1px solid #b72e00;
      cursor:pointer;
    }
    .btn_login:hover{
      background:#b72e00;
      border: 1px solid #b72e00;
    }
    .btn_mypage{
      background: #0098cc;
      border: 1px solid #006d92;
      cursor:pointer;
    }
    .btn_mypage:hover{
      background:#006d92;
      border: 1px solid #006d92;
    }


  }
}

</style>
